import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import cjaAnalytics from 'yoda-core-components/lib/helpers/Analytics/CJAAnalytics';
import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import { logwebvitals } from 'yoda-site-components/lib/middlewares/WebvitalsMiddleware';
import get from 'lodash/get';
import * as MyOrdersActionTypes from '../actionTypes/MyOrdersActionTypes';
import * as CurbsideActionTypes from '../actionTypes/CurbsideActionTypes';
import OrderActionFilter from '../analytics/OrderActionFilter';

const orderActionFilter = new OrderActionFilter();

const hasCJAPageEvent = (pageName) => {
    const pageEvents = window?.adobeDataLayer?.filter?.((e) => e.event === 'pageView');
    return pageEvents?.length > 0 && pageEvents[pageEvents.length - 1]?.page?.name === pageName;
};

/**
 * This function will used only for redux middleware only to track tagging based on action request
 */
const PostPurchaseAnalyticsMiddleware = store => next => action => { // eslint-disable-line
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        const errorMes = 'error';

        /**
         * component can trigger an action only for tagging
         * action should contain analytics object as mandatory
         * @param analytics.type - {string}  - tagging key
         * @param analytics.JCPDL - {Object}  - required additional details for tagging event
         */
        const { enableCJAAnalytics = false } = store.getState()?.context?.featureFlags || {};
        let cjaPageName = null;
        let cjaPageType = null;

        try {
            switch (action.type) {
                case MyOrdersActionTypes.PAGE_LOAD_ANALYTICS_ACTION:
                    // console.log('********* CkMiddleware ORDER_PAGE_ANALYTICS_ACTION ***********');
                    digitalData = orderActionFilter.getOrderPageDL(store, action.payload);
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = 'digitalDataReady';
                    logwebvitals(store, digitalData);
                    cjaPageName = action?.payload?.pageName || '';
                    cjaPageType = 'account';
                    break;
                case CurbsideActionTypes.CURBSIDE_PICKUP_LOAD_ANALYTICS_ACTION:
                    digitalData = orderActionFilter.getCurbsidePickupAnalyticsAction(
                        store,
                        action.payload
                    );
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = 'digitalDataReady';
                    cjaPageName = 'store selection';
                    cjaPageType = 'curbside pickup';
                    break;
                case CurbsideActionTypes.CURBSIDE_EVENTS_ANALYTICS_ACTION:
                    digitalData = get(action, 'data', '');
                    analyticsEventName = get(action, 'eventName', '');
                    break;
                case CurbsideActionTypes.CURBSIDE_STATUS_INFO_ACTION:
                    digitalData = orderActionFilter.getCurbsideStatusPageDetails(
                        store,
                        action.payload
                    );
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = 'digitalDataReady';
                    cjaPageName = 'pickup process';
                    cjaPageType = 'curbside pickup';
                    break;
                case MyOrdersActionTypes.MKTPLC_RETURNS_ANALYTICS_ACTION:
                    digitalData = orderActionFilter.getMktPlcReturnDetails(store, action.payload);
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = get(action, 'eventName', '');
                    break;
                case MyOrdersActionTypes.MKTPLC_CONFIRM_RETURNS_ANALYTICS_ACTION:
                    digitalData = orderActionFilter.getMktPlcConfirmReturnDetails(
                        store,
                        action.payload
                    );
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = get(action, 'payload.eventName', '');
                    break;
                case MyOrdersActionTypes.RETURNS_ANALYTICS_ACTION:
                    digitalData = orderActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = get(action, 'eventName', '');
                    break;
                case 'Error':
                    throw errorMes;
                default:
                    break;
            }
            if (analyticsEventName || digitalData) {
                /* eslint-disable no-console */
                // console.log('********** Just before firing TRACK **********');
                digitalData.dataVersion = 1;
                analytics.track(analyticsEventName, digitalData);
            }
            if (enableCJAAnalytics && cjaPageName && !hasCJAPageEvent(cjaPageName)) {
                cjaAnalytics.track(
                    'pageView',
                    buildCJAPageViewPayload(
                        {
                            name: cjaPageName,
                            type: cjaPageType,
                            siteSection: 'account',
                            category: { primary: 'account' },
                            tech: { version: 'apollo 1 2017 redesign yoda post purchase' },
                        },
                        {},
                        { interactionName: 'regular_pageview' }
                    )
                );
            }
        } catch (error) {
            /* eslint-disable no-console */
            console.log(error);
        }
    }
    if (action.type) {
        return next(action);
    }
};
export default PostPurchaseAnalyticsMiddleware;
